import { getAsyncPaymentBrowserInfo } from 'pmt-utils/browser'
import { createFormatter } from 'pmt-utils/format'
import { formatPriceWithCurrency } from 'pmt-utils/currency'
import { formatItemsMap } from './item'

// /!\ We format UserCheck here not really a transaction/payment.

export const formatAmount = payment => {
  payment.amount = Number(payment.amount || 0)
  payment.amountFormatted = formatPriceWithCurrency(payment.amount, payment.currency)

  if (!payment.tips && !payment.tip) {
    payment.tips = 0
  }
  if (!payment.tips) {
    payment.tips = payment.tip || 0
  } else {
    payment.tip = payment.tips || 0
  }

  payment.totalWithTipFormatted = formatPriceWithCurrency(
    payment.amount + payment.tips,
    payment.currency
  )

  payment.irlTotalAmount = Number(payment.irlTotalAmount || 0)
  payment.totalIrlAmountFormatted = formatPriceWithCurrency(
    payment.irlTotalAmount,
    payment.currency
  )

  payment.pspTotalAmount = Number(payment.pspTotalAmount || 0)
  payment.totalPspAmountFormatted = formatPriceWithCurrency(
    payment.pspTotalAmount,
    payment.currency
  )

  payment.vouchersTotalAmount = Number(payment.vouchersTotalAmount || 0)
  payment.totalVouchersAmountFormatted = formatPriceWithCurrency(
    payment.vouchersTotalAmount,
    payment.currency
  )

  if (payment.share) {
    payment.share.amountPerPersonFormatted = formatPriceWithCurrency(
      payment.share.amountPerPerson,
      payment.currency
    )
  }

  payment.paymentType = payment.type

  return payment
}

/**
 * Data neeeded for 3DS v2
 *
 * https://www.notion.so/paymytable/Mangopay-3DS2-543d705dd4534a908b3dc1a64882e7a6.
 */
const formatBrowserInfo = data => ({
  ...data,
  browserInfo: getAsyncPaymentBrowserInfo(),
})

export const formatPayment = createFormatter(formatAmount, formatItemsMap, formatBrowserInfo)

export const formatPaymentMade = createFormatter(paymentMade => {
  return {
    ...paymentMade,
    totalWithTipFormatted: formatPriceWithCurrency(
      paymentMade.amount + paymentMade.tips,
      paymentMade.currency
    ),
  }
})
